<script>
  import { _ } from 'svelte-i18n';

  import Step from "./Step.svelte";
  import StepHeader from "./StepHeader.svelte";
  import { save } from "./ExerciseVerification.svelte";

  export let course;
  export let mod;
  export let step;
  export let justified;
  export let prevFn;
  export let nextFn;

  let passedExercise;

  let answer = "";

  function checkAssignments(ev) {
    passedExercise = true;

    let assignment_object = [{
      givenAnswer: answer
    }]

    save(mod, step, assignment_object);
  }

</script>

<Step {justified} {prevFn} {nextFn}>
  <StepHeader {course} {mod} />

  <div class="w-11/12 mt-4 mb-4 bg-base-200">

    {#if passedExercise === true}
      <div class="my-8">
        <img class="mx-auto" src="/assets/test_passed.svg" />
        <p class="text-4xl pt-4 font-bold text-center uppercase"> {$_('course.good_job')} </p>
      </div>

    {:else}
      <div class="card w-3/4 my-10 mx-auto pt-4 relative">
        <div class="card-body pt-2 px-16 z-20">
          <div class="prose max-w-none">
            <h2 class="text-4xl font-bold text-center mb-2"> {step.title} </h2>

            <h5 class="font-bold text-center">
              {@html step.content}
            </h5>
          </div>

          <textarea class="textarea textarea-bordered textarea-lg mb-10"
          bind:value="{answer}"
          placeholder="{$_('course.answer_here')}"></textarea>

          <button class="btn btn-primary" on:click="{checkAssignments}">
            {$_('course.done')}
          </button>
        </div>
      </div>
    {/if}

  </div>
</Step>